/**
 * Created by zcr on 2018/5/5.
 */
export default {
  saveMsg(state, msg) {
    state.msg = msg;
  },

  setDataByName(state, payload) {
    if (!!payload.index) {
      state[payload.key][payload.index] = payload.val;
    } else {
      state[payload.key] = payload.val;
    }
  },
  setLisDataByKey(state, payload) {
    if (!!payload.key3) {
      state[payload.key][payload.index][payload.key2][payload.index3][
        payload.key3
      ] = payload.val;
    } else {
      state[payload.key][payload.index][payload.key2] = payload.val;
    }
  },
  onAvigationList(state, value) {
    state.navigationList = value;
  },
  onRoadInformation(state, value) {
    state.roadInformation = value;
  },
  onRoutePlanning(state, value) {
    state.RoutePlanning = value;
  },
  updateMyPosition(state, value) {
    state.myPosition = value;
  },
};
